// Version management utilities

export const APP_VERSION = '1.1.4'; // Keep in sync with the latest entry in data/changelog.ts

export function getAppVersion(): string {
  // Try to get from localStorage first (for updates)
  const storedVersion = localStorage.getItem('appVersion');
  if (storedVersion) {
    return storedVersion;
  }
  
  // Return default version
  return APP_VERSION;
}

export function setAppVersion(version: string): void {
  localStorage.setItem('appVersion', version);
}

export function getLastUpdateCheck(): Date | null {
  const lastCheck = localStorage.getItem('lastUpdateCheck');
  if (lastCheck) {
    return new Date(lastCheck);
  }
  return null;
}

export function setLastUpdateCheck(): void {
  localStorage.setItem('lastUpdateCheck', new Date().toISOString());
}

export function compareVersions(version1: string, version2: string): number {
  const v1Parts = version1.split('.').map(Number);
  const v2Parts = version2.split('.').map(Number);
  
  const maxLength = Math.max(v1Parts.length, v2Parts.length);
  
  for (let i = 0; i < maxLength; i++) {
    const v1Part = v1Parts[i] || 0;
    const v2Part = v2Parts[i] || 0;
    
    if (v1Part > v2Part) return 1;
    if (v1Part < v2Part) return -1;
  }
  
  return 0;
}

